// src/plugins/metaRouter.js
export default {
  install(app, { router }) {
    let metaPressed = false

    window.addEventListener('keydown', (e) => { if (e.metaKey || e.ctrlKey) metaPressed = true })
    window.addEventListener('keyup', (e) => { if (!e.metaKey && !e.ctrlKey) metaPressed = false })
    window.addEventListener('blur', () => { metaPressed = false })

    const originalPush = router.push.bind(router)

    router.push = function (to) {
      if (metaPressed) {
        const resolved = router.resolve(to)
        window.open(resolved.href, '_blank')
        metaPressed = false
        return Promise.resolve()
      }
      return originalPush(to)
    }
  }
}